<template>
    <div class='barra-lateral-direita' v-if='getShowBarRight'>
      <div class="contacts-whatsapp">
        <form class='share-client direita' @submit.prevent>
          <!--<input class='esquerda input-button submit-reset ' type='submit'>-->
          <div class="search-client">
            <div class="d-flex" style="align-items: center">
              <input @click.prevent v-model="cnpj" style="flex:2" class='esquerda input-text form-control round-input'
                type='text' placeholder="Procure um contato...">
              <button @click.prevent="searchClients" class="form-control" id="search-button"><i class="fas fa-search" />
                Buscar</button>
            </div>
          </div>
          <h5 class="mt-2" v-if="allClients && allClients.length > 0">Selecione um cliente:</h5>
          <div v-if="allClients && allClients.length > 0" id="search-results">
            <div @click.prevent="chooseAndInsertClient(client.id)" class='show-share' v-for="client in allClients"
              :key='client.id'>
              <div v-if="client" class='conteudo-share'>
                <p class='formatName'>{{ client.name }}</p>
                <p v-if="client.phone1" class='formatPhone'><strong>Telefone 1:</strong> {{ formTelefone(client.phone1) }}</p>
                <p v-if="client.phone2" class='formatPhone'><strong>Telefone 2:</strong> {{ formTelefone(client.phone2) }}</p>
                <p v-if="client.mobile" class='formatPhone'><strong>Celular:</strong> {{ formTelefone(client.mobile) }}</p>
              </div>
            </div>
          </div>
        </form>
  
        <div class='menu-lateral-direito' v-if="(preSelectShow && preSelectShow.phone1 != null && selected && !msgError)">
          <div id="contact-container">
            <div class="w-100">
              <div>
                <p class="sublinhado-embaixo mb-3 text-center" style="align-self: center; font-size: 16px">{{ (preSelectShow &&
                  preSelectShow.name != null) ? preSelectShow.name : 'Nome' }}</p>
              </div>
              <div class='m-1' v-if="preSelectShow.cpf_cnpj">
                <p class="mb-0"><b>CPF/CNPJ: </b></p>
                <p class="mb-0">{{ formata_cpf_cnpj(preSelectShow.cpf_cnpj) }}</p>
              </div>
              <div class='m-1' v-if="preSelectShow.phone1">
                <div class='mb-0'>
                  <p class="mb-0"><b>TELEFONE 1: </b></p>
                  <p class="mb-0">{{ formTelefone(preSelectShow.phone1) }}</p>
                </div>
              </div>
              <div class='m-1' v-if="preSelectShow.phone2">
                <div class='mb-0'>
                  <p class="mb-0"><b>TELEFONE 2: </b></p>
                  <p class="mb-0">{{ formTelefone(preSelectShow.phone2) }}</p>
                </div>
              </div>
              <div class='m-1' v-if="preSelectShow.mobile">
                <div class='mb-0'>
                  <p class="mb-0"><b>CELULAR: </b></p>
                  <p class="mb-0">{{ formTelefone(preSelectShow.mobile) }}</p>
                </div>
              </div>
              <div 
                v-if="(
                  preSelectShow.phone1 && preSelectShow.phone1.length >= 8 ||
                  preSelectShow.phone2 && preSelectShow.phone2.length >= 8 ||
                  preSelectShow.mobile && preSelectShow.mobile.length >= 8
                )"
              >
              <div class="m-3">
                <span><strong>Selecione um telefone:</strong></span>
                <select v-model="clientPhone" class="form-control">
                  <option v-if="preSelectShow.phone1 && preSelectShow.phone1.length >= 8">{{ formTelefone(preSelectShow.phone1) }}</option>
                  <option v-if="preSelectShow.phone2 && preSelectShow.phone2.length >= 8">{{ formTelefone(preSelectShow.phone2) }}</option>
                  <option v-if="preSelectShow.mobile && preSelectShow.mobile.length >= 8">{{ formTelefone(preSelectShow.mobile) }}</option>
                </select>
              </div>
                <div class='wpp-call' @click="call_client()">
                  <div class="direita d-flex justify-content-center">
                    <p class='esquerda' style="align-self: center"><b>📞 Ligar para Cliente</b></p>
                  </div>
                </div>
              </div>
              <div v-else class="text-center">
                <span><strong>O cliente não possui telefones válidos em seu cadastro!</strong></span>
              </div>
            </div>
  
            <slot></slot>
          </div>
        </div>
  
        <div class='menu-lateral-direito' v-if="!allClients && !selected && msgError">
          <div id="contact-container">
            <div class="text-center">
              <div class='m-1'>
                <div class='mb-0'>
                  <p class="mb-0">A pesquisa deve conter pelo menos três dígitos...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class='menu-lateral-direito' v-if="loading && !allClients && !selected && !msgError">
          <div id="contact-container">
            <div class="text-center">
              <div class='m-1'>
                <div class='mb-0'>
                  <b-spinner variant="dark" small></b-spinner>
                  <p class="mb-0">Processando, por favor, aguarde...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class='menu-lateral-direito' v-if="allClients && allClients.length == 0 && loading && !selected && !msgError">
          <div id="contact-container">
            <div class="text-center">
              <div class='m-1'>
                <div class='mb-0'>
                  <p class="mb-0">Nenhum contato encontrado...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class='menu-lateral-direito' v-if="!loading && !selected && !msgError">
          <div id="contact-container">
            <div class="text-center">
              <div class='m-1'>
                <div class='mb-0'>
                  <p class="mb-0"><strong>Campos válidos para pesquisa:</strong> Telefones, Nome e CPF/CNPJ.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions } from "vuex";
  import phoneClient from "../../store/modules/phoneClient";
  import { formata_cpf_cnpj } from "../../validaCPFeCNPJ";
  import { BSpinner } from "bootstrap-vue";
  import swal from "sweetalert";
  const connection = io.connect(`${location.protocol}//${location.hostname}:3002/`);
  Vue.component("b-spinner", BSpinner);
  
  export default {
    data() {
      return {
        formata_cpf_cnpj: formata_cpf_cnpj,
        cnpj: "",
        clientID: "",
        editPhone1: true,
        editPhone2: true,
        selected: false,
        msgError: false,
        loading: false,
        clientPhone: null
      };
    },
    watch: {
      cnpj: function (value) {
        if (!value) {
          if (value.length == 0) {
            this.selected = false;
            this.msgError = false;
            this.loading = false;
          } else if (value.length < 3) {
            this.selected = false;
            this.msgError = true;
            this.loading = false;
          }
  
          this.clearAllClients();
          return;
        }
      },
    },
    computed: {
      ...mapGetters([
        "allClients",
        "getShowBarRight",
        "preSelectShow",
        "getCnpj",
        "getShowSpearhead",
        "getClientInAttendance"
      ]),
    },
    methods: {
      ...mapActions([
        "fetchClients",
        "chooseClients",
        "chooseClient",
        "fetchProtocol",
        "clearAllClients",
        "chooseClientCnpj",
        "setShowSpearhead",
        "setShowBarRight",
        "preselectClient",
        "startConversation",
      ]),
      chooseAndInsertClient(id) {
        this.allClients.forEach((x) => {
          if (x.id == id) {
            this.preselectClient(x);
            this.fetchProtocol();
          }
        });
        this.clearAllClients();
        this.selected = true;
      },
      open_client() {
        if (this.clientPhone) {
          this.setShowBarRight();
          this.startConversation(this.clientPhone);
        } else {
          Swal.fire('Nenhum telefone selecionado!', 'Selecione um telefone na listagem', 'warning')
        }
      },
      call_client() {
        const selectedPhone = this.clientPhone
        if(selectedPhone){
          connection.emit('Originate', {
            calltype: 'outgoing',
            extension: user.getExtension(),
            phone: this.formatPhoneToCall(selectedPhone)
          });
        } else {
          Swal.fire('Nenhum telefone selecionado!', 'Selecione um telefone na listagem', 'warning')
        }
      },
      formTelefone(tel) {
        tel = tel.replace(/\D/g, "");
        if (tel.length == 10 || tel.length == 11) {
          const v1 = tel.replace(/\D/g, "");
          const v2 = v1.replace(/^(\d{2})(\d)/g, "($1) $2");
          const v3 = v2.replace(/(\d)(\d{4})$/, "$1-$2");
          return v3;
        }
        tel = tel.replace(/\D/g, "");
        tel = tel.replace(/^(\d)/, "+$1");
        tel = tel.replace(/(.{3})(\d)/, "$1($2");
        tel = tel.replace(/(.{6})(\d)/, "$1)$2");
        if (tel.length == 12) {
          tel = tel.replace(/(.{1})$/, "-$1");
        } else if (tel.length == 13) {
          tel = tel.replace(/(.{2})$/, "-$1");
        } else if (tel.length == 14) {
          tel = tel.replace(/(.{3})$/, "-$1");
        } else if (tel.length == 15) {
          tel = tel.replace(/(.{4})$/, "-$1");
        } else if (tel.length > 15) {
          tel = tel.replace(/(.{4})$/, "-$1");
        }
  
        tel = tel.replace("(", " (");
        tel = tel.replace(")", ") ");
        return tel;
      },
      formatPhoneToCall(phone) {
        let newPhone = phone.replace(/\D/g, "");
        return newPhone.slice(0, 2) == "55" ? '0' + newPhone.slice(2) : newPhone;
      },
      searchClients() {
        if (this.cnpj.length == 0) {
          this.selected = false;
          this.msgError = false;
          this.loading = false;
        } else if (this.cnpj.length < 3) {
          this.selected = false;
          this.msgError = true;
          this.loading = false;
          this.clearAllClients();
        } else {
          this.clearAllClients();
          this.selected = false;
          this.msgError = false;
          this.loading = true;
          this.fetchClients(this.cnpj);
        }
      },
      editPhoneToDial(index) {
        if (index == 1) {
          this.editPhone1 = !this.editPhone1;
          this.getClientInAttendance.original_phone = this.getClientInAttendance.phone
        } else {
          this.editPhone2 = !this.editPhone2
          this.getClientInAttendance.original_phone = this.getClientInAttendance.phone2
        }
      }
    },
  };
  </script>
   
  <style>
  .barra-lateral-direita {
    width: 350px;
    padding: 15px 5px 15px 5px;
  }
  
  .barra-lateral-direita>ul {
    margin-bottom: 20px;
  }
  
  .menu-lateral-direito {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .share-client input[type="submit"] {
    background-image: url("/imgs/icons/search-white.svg");
    background-repeat: no-repeat;
    margin: 0;
    background-position: center;
    background-size: 20px 20px;
    display: flex;
  }
  
  .area-share {
    position: absolute;
    width: 95%;
    top: 6.7em;
    max-height: 18em;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #6babb8;
  }
  
  .show-share {
    z-index: 1;
    display: contents;
    color: black;
  }
  
  .conteudo-share {
    border-top: solid 1px lightgray;
    width: 100%;
    display: inline-block;
    text-align: start;
    padding: 5px;
  }
  
  .formatName {
    font-weight: bold;
  }
  
  .formatPhone {
    font-style: italic;
  }
  
  .conteudo-share:hover {
    background-color: gray;
  }
  
  .espaco-cima-baixo p,
  .espaco-cima-baixo {
    margin: 16px 0 10px 0;
  }
  
  .sublinhado-embaixo {
    border-bottom: solid 1px white;
    padding: 10px 0 10px 0;
  }
  </style>
   
  <style scoped>
  #search-button {
    flex: 1 1 0%;
    padding: 1px;
    margin: 5px;
    border: 2px solid lightgray;
    border-radius: 5px !important;
    background-color: #1c869a;
    color: white;
    transition: 0.3s;
  }
  
  #search-button:hover {
    background-color: #104b57;
  }
  
  #search-results {
    max-height: 75vh;
    overflow-y: auto;
    width: 23em;
    overflow-x: hidden;
    background-color: #84a9b1;
  }
  
  #contact-container {
    display: flex;
    justify-content: center;
    border: 2px solid rgba(211, 211, 211, 0.416);
    border-radius: 10px !important;
    padding: 10px;
    width: 21em;
    margin: 10px;
  }
  
  .round-input {
    border-radius: 0.25em !important;
  }
  
  .phone-edit-input {
    border-radius: 0.25em !important;
    width: 100%;
  }
  
  .wrapper-call-edite {
    display: flex;
    justify-content: space-between;
  }
  
  .wpp-call {
    margin: 5px;
    border: solid 2px green;
    border-radius: 8px;
    padding: 0px;
    cursor: pointer;
    background-color: #27ae60;
    transition: 0.2s;
  }
  
  .wpp-call:hover {
    color: green;
    background-color: white;
  }
  
  .phone-edite {
    width: 25%;
    border-radius: 5px;
    padding: 0px;
    cursor: pointer;
    transition: 0.2s;
    background-color: #276dae;
    border: solid 2px #285b8b;
  }
  
  .tabContacts {
    color: white;
    border: 1px solid white;
  }
  
  .tabContacts:hover {
    background-color: white;
    color: black;
  }
  
  .search-client {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .active {
    font-weight: bold;
  }
  
  .custom-tabs li:nth-child(even) {
    margin-left: 5px;
  }
  </style>
  